import { useNavigate } from 'react-router-dom'
import successIcon from '../assets/icons/success.png'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function SetupSuccess() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  // Auto redirect after a short delay
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/flowers')
    }, 3000); // Redirect after 3 seconds
    
    return () => clearTimeout(timer);
  }, [navigate]);
  
  // Handle manual continue
  const handleContinue = () => {
    navigate('/flowers')
  }

  const handleTurnOnNotification = () => {
    // In a real app, you'd request notification permissions here
    // For now, just redirect to the home page
    navigate('/flowers')
  }

  return (
    <div className="min-h-screen flex flex-col bg-white p-6">
      <div className="flex-1 flex flex-col items-center justify-center">
        <img 
          src={successIcon} 
          alt={t('pages.setupSuccess.successIconAlt')} 
          className="w-24 h-24 mb-6"
        />
        
        <h1 className="text-2xl font-bold text-center mb-2">
          {t('pages.setupSuccess.title')}
        </h1>
        
        <p className="text-gray-600 text-center mb-12">
          {t('pages.setupSuccess.description')}
        </p>
        
        <button
          onClick={handleTurnOnNotification}
          className="w-full py-4 bg-[#FDEDB6] text-[#262626] font-medium rounded-full mb-4"
        >
          {t('pages.setupSuccess.turnOnNotifications')}
        </button>
        
        <button
          onClick={handleContinue}
          className="w-full py-4 bg-[#F9D348] text-[#262626] font-medium rounded-full"
        >
          {t('pages.setupSuccess.continue')}
        </button>
      </div>
    </div>
  )
}
